/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentRtSystemDto } from './QaEquipmentRtSystemDto';
import {
    QaEquipmentRtSystemDtoFromJSON,
    QaEquipmentRtSystemDtoFromJSONTyped,
    QaEquipmentRtSystemDtoToJSON,
} from './QaEquipmentRtSystemDto';

/**
 * 
 * @export
 * @interface QaRtSystemTemplateContainerEntryDto
 */
export interface QaRtSystemTemplateContainerEntryDto {
    /**
     * 
     * @type {boolean}
     * @memberof QaRtSystemTemplateContainerEntryDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {QaEquipmentRtSystemDto}
     * @memberof QaRtSystemTemplateContainerEntryDto
     */
    system: QaEquipmentRtSystemDto;
    /**
     * 
     * @type {string}
     * @memberof QaRtSystemTemplateContainerEntryDto
     */
    $type?: QaRtSystemTemplateContainerEntryDtoTypeEnum;
}


/**
 * @export
 */
export const QaRtSystemTemplateContainerEntryDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoQaRtSystemTemplateContainerEntryDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.QaRtSystemTemplateContainerEntryDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type QaRtSystemTemplateContainerEntryDtoTypeEnum = typeof QaRtSystemTemplateContainerEntryDtoTypeEnum[keyof typeof QaRtSystemTemplateContainerEntryDtoTypeEnum];



/**
 * Check if a given object implements the QaRtSystemTemplateContainerEntryDto interface.
 */
export function instanceOfQaRtSystemTemplateContainerEntryDto(value?: unknown): value is QaRtSystemTemplateContainerEntryDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(QaRtSystemTemplateContainerEntryDtoTypeEnum)[0];
}

export function QaRtSystemTemplateContainerEntryDtoFromJSON(json: any): QaRtSystemTemplateContainerEntryDto {
    return QaRtSystemTemplateContainerEntryDtoFromJSONTyped(json, false);
}

export function QaRtSystemTemplateContainerEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaRtSystemTemplateContainerEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'system': QaEquipmentRtSystemDtoFromJSON(json['system']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function QaRtSystemTemplateContainerEntryDtoToJSON(value?: QaRtSystemTemplateContainerEntryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'isEnabled': value['isEnabled'],
        'system': QaEquipmentRtSystemDtoToJSON(value['system']),
        '$type': value['$type'],
    });
}

